<template>
    <div class="cz3__customizer">
        <div class="cz3__preview">
            <product-preview />
        </div>

        <div class="cz3__selectors">
            <div class="cz3__selectors--inner">
                <product-info class="cz3__hide-sm" />

                <progress-bar/>

                <transition name="cz3__fade-fast-slide" mode="out-in">
                    <step-group-or-not key="start" v-if="selectedStep === 'start'" />

                    <step-item-colors key="itemColors" v-if="selectedStep === 'itemColors'" />

                    <step-design-side key="design-1" v-if="selectedStep === 'design-1'" :design-index="0" :surface-index="0" />

                    <step-design-side key="design-1-1" v-if="selectedStep === 'design-1-1'" :design-index="0" :surface-index="1" />

                    <step-design-side key="design-2" v-if="selectedStep === 'design-2'" :design-index="2" :surface-index="0" />

                    <step-design-side key="design-2-1" v-if="selectedStep === 'design-2-1'" :design-index="2" :surface-index="1" />

                    <step-design-side key="design-3" v-if="selectedStep === 'design-3'" :design-index="4" :surface-index="0" />

                    <step-design-side key="design-3-1" v-if="selectedStep === 'design-3-1'" :design-index="4" :surface-index="1" />

                    <step-review key="review" v-if="selectedStep === 'review'" />
                </transition>
            </div>
        </div>

        <transition name="cz2__fade-secondary" @after-enter="afterEnterTransition">
            <product-help v-if="showHelp === 'help'">
            </product-help>
        </transition>

        <transition name="cz2__fade-secondary" @after-enter="afterEnterTransition">
            <product-help-child v-if="showHelp && showHelp.step === 'help-child'">
            </product-help-child>
        </transition>

        <transition name="cz2__fade">
            <image-gallery-small v-if="showImageGallery">
            </image-gallery-small>
        </transition>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__customizer {
            position: absolute;

            left: 0;
            top: 0;

            width: 100%;
            height: 100%;

            display: flex;
            flex-direction: column;

            @include respond-above(sm) {
                flex-direction: row;
            }
        }

        .cz3__preview {
            position: relative;

            flex: 1 1 0;

            z-index: 1;

            @include respond-above(sm) {
                z-index: 3;
            }
        }

        .cz3__selectors {
            position: relative;

            z-index: 2;

            background: #fafafa;

            @include respond-above(sm) {
                width: 512px;
            }
        }

        .cz3__selectors--inner {
            flex: 0 0 auto;

            display: flex;
            flex-direction: column;

            gap: 24px;

            @include respond-above(sm) {
                height: 100%;

                gap: 40px;
            }
        }
    }
</style>

<script>
    import ProductInfo from './ProductInfo.vue';
    import ProductPreview from './ProductPreview.vue';
    import ProgressBar from './ProgressBar.vue';
    import StepGroupOrNot from './StepGroupOrNot.vue';
    import StepItemColors from './StepItemColors.vue';
    import StepDesignSide from './StepDesignSide.vue';
    import StepReview from './StepReview.vue';
    import ImageGallerySmall from './ImageGallerySmall.vue';
    import ProductHelp from './ProductHelpNew.vue';
    import ProductHelpChild from './ProductHelpChildNew.vue';

    import 'vue-popperjs/dist/vue-popper.css';

    export default {
        components: {
            ProductInfo,
            ProductPreview,
            ProgressBar,
            StepGroupOrNot,
            StepItemColors,
            StepDesignSide,
            ImageGallerySmall,
            StepReview,
            ProductHelp,
            ProductHelpChild,
        },

        computed: {
            selectedStep() {
                return this.$store.state.selectedStepV3;
            },

            showImageGallery() {
                const small = this.$store.state.windowWidth < 1024;

                return small && this.$store.state.showImageGalleryV3;
            },

            showHelp() {
                return this.$store.state.helpV3;
            },
        },

        methods: {
            afterEnterTransition() {
                this.$store.dispatch('globalEvent', {
                    event: 'secondaryEntered',
                });
            },
        },
    };
</script>
